
export function getRouteExp(path: string): RegExp {

  path = path.trim();
  const pattern = `^${path.split('/')
    .filter(p => !!p)
    .map(p => {
      if (p === '*') return '\/.*';

      p = p.replace('*', '.*?');

      if (p.startsWith(':')) {
        if (p.endsWith('?'))
          return `(\/(?<${p.substring(1, p.length - 1)}>[^/?]+))?`;

        else
          return `\/(?<${p.substring(1)}>[^/?]+)`;
      }

      return `\/${p}`;
    })
    .reduce((p, pp) => {

      return `${p}${pp}`
    }, '')}\/?(\\?(?<__search>.*))?$`;

  return new RegExp(pattern, 'gi');
}
